import { render } from "./KeytsTable.vue?vue&type=template&id=97b8e1d6&scoped=true"
import script from "./KeytsTable.vue?vue&type=script&lang=js"
export * from "./KeytsTable.vue?vue&type=script&lang=js"

import "./KeytsTable.vue?vue&type=style&index=0&id=97b8e1d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97b8e1d6"]])

export default __exports__